import { OwnerStateThemeType } from './'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'

export default {
  MuiSelect: {
    defaultProps: {
      IconComponent: ExpandLessIcon,
    },
    variants: [
      {
        props: { variant: 'outlined', size: 'small' },
        style: ({}: OwnerStateThemeType) => ({
          '& .MuiSelect-select': {
            padding: '7px 11px !important',
          },
        }),
      },
      {
        props: { variant: 'outlined', size: 'small', multiple: true },
        style: ({}: OwnerStateThemeType) => ({
          '& .MuiSelect-select.MuiSelect-multiple': {
            padding: '7px 11px !important',
          },
        }),
      },
    ],
    styleOverrides: {
      select: ({ theme }: OwnerStateThemeType) => ({
        color: theme.palette.text.primary,
        fontWeight: 400,
        backgroundColor: theme.palette.background.paper,

        '&:hover': {
          backgroundColor: theme.palette.background.paper,
        },
        '&.Mui-focused': {
          backgroundColor: theme.palette.background.paper,
        },
      }),
      icon: ({ theme }: OwnerStateThemeType) => ({
        color: theme.palette.text.primary,
        fontSize: '18px',
        transition: '0.2s',
      }),
      root: ({ theme }: OwnerStateThemeType) => ({
        borderRadius: '8px',
        backgroundColor: `${theme.palette.background.paper} !important`,
        minHeight: '35.7px',

        '& .MuiTypography-root': {
          color: theme.palette.text.primary,
          fontWeight: 400,
        },

        '&.Mui-error .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.error.main} !important`,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          transition: '0.2s',
          border: '1px solid',
          borderColor: theme.palette.success.main,
        },

        '&:not(.Mui-focused):not(.Mui-disabled):not(.Mui-error):hover .MuiOutlinedInput-notchedOutline':
          {
            borderColor: theme.palette.text.primary,
          },
      }),
    },
  },
}
